import { isMobile } from "react-device-detect";
import { Link, NavLink } from "common/src/router/compat";
import styled from "styled-components";
import bankid from "./../assets/icon-component/BankID_logo_white.svg";
import "../assets/css/flex-table.css";

const limitButtonClassBySkin = {
  pub: "align-self-end btn btn-first transaction-btn mt-5",
  cac: "align-self-end btn btn-first transaction-btn mt-5",
  hyc: "align-self-end btn btn-first transaction-btn mt-5",
};

const loginButtonClassBySkin = {
  abc: "btn btn-first col-md-3 my-4",
};

const hideLogoWrapperClassOnPlayerMobileBySkin = {
  abc: true,
};

const inputProps = (props) => {
  if (props.cp)
    return props.error
      ? "is-invalid custom-input number"
      : "custom-input number";
  if (props.customControl) return "custom-control-input";
  if (props.inputLg)
    return props.realityCheck
      ? "form-control input-lg is-invalid "
      : "form-control input-lg";
  if (props.limit) return " form-control";
  if (props.bonus) return `form-control ${props.propsCol && props.propsCol}`;
  if (props.validform)
    return props.errorprop ? "form-control is-invalid" : "" + "form-control";
  if (props.validformWithdrawal)
    return props.errorprop
      ? "form-control col-4 is-invalid"
      : "" + "form-control col-4";
  if (props.validformWithdrawalBank)
    return props.errorprop
      ? "form-control is-invalid wd-bank"
      : "" + "form-control wd-bank";
  if (props.validFormNumber)
    return `is-invalid form-control number + ${
      props.spanPadding && props.spanPadding
    }`;
  else return `form-control number`;
};

const autoFocusProps = (props) => {
  if (props.autoFocus) {
    return true;
  } else {
    return false;
  }
};

const selectProps = (props) => {
  if (props.selecCenter) {
    if (props.error) return "is-invalid form-control text-center";
    else return "form-control text-center";
  }
  if (props.formControll) return "form-control";
  if (props.formControllSpan) return "form-control arrow";
  if (props.deposit) return "form-control is-invalid";
  else return ` form-control ${props.emptyPeriod}`;
};

const buttonProp = (props) => {
  if (props.btnsolo) return "btn";
  if (props.supportchat) return "sc-gjNHFA geGguR";
  if (props.btn) return `btn btn-first ${props.spancol && props.spancol}`;
  if (props.btnCol) return "btn btn-first col-md-4";
  if (props.btnColMd3) return "btn btn-first col-md-3";
  if (props.btnsecond)
    return `btn btn-second ${props.spancol && props.spancol}`;
  if (props.limit)
    return limitButtonClassBySkin[props.theme.skin] || "btn btn-first col-md-2";
  if (props.selfExcludionProp) return "btn btn-first col-md-3 mt-3";
  if (props.selfexcludion) return "btn btn-first col-md-3";
  if (props.bonus)
    return "btn btn-first col-xs-12 col-md-12 col-lg-3 text-uppercase";
  if (props.bonusCode) return "btn btn-first col-sm-12 col-md-3 col-ld-3";
  if (props.fourth) return `btn btn-fourth ${props.colfourth}`;
  if (props.third) return `btn btn-third ${props.colthird}`;
  if (props.dialog) return "btn btn-fourth col-md-3 col-sm-4 col-5";
  if (props.banktransfer) return "btn btn-first col-md-3 col-sm-4 col-5";
  if (props.btnsm) return "btn btn-first col-sm-12";
  if (props.dresponse) return "btn btn-first mt-5";
  if (props.deposit)
    return props.hidden ? "btn btn-deposit hidden" : "btn btn-deposit";
  if (props.continue)
    return props.hidden ? "btn btn-continue hidden" : "btn-continue";
  if (props.resetPass) return "btn btn-first col-md-4 mt-4";
  if (props.loginbtn)
    return (
      loginButtonClassBySkin[props.theme.skin] || "btn btn-first col-md-6 my-4"
    );
  if (props.register) return "btn btn-first col-md-3";
  if (props.modal) return "btn btn-nb-bold";
  if (props.hidelink) return props.hidden ? "hidden" : "";
  if (props.gdpr) return `btn btn-first ${props.spancol && props.spancol}`;
  if (props.regIdin)
    return `btn btn-first col-md-4 col-sm-4 col-6 button-bank-id`;
  if (props.btnStripped)
    return `btn btn-stripped ${props.spancol && props.spancol}}`;
  if (props.btnBold) return `btn btn-nb-bold`;
  if (props.btnLight) return `btn btn-nb-light`;
  if (props.btnlogout)
    return props.btnprofilemenu ? `btn bnt-logout-profile` : `btn bnt-logout`;
  if (props.pagelink) return `page-link`;
  if (props.gotogames) return "btn btn-first mt-4";
  if (props.balancecolor) return "btn btn-balance-color";
  else return "";
};

export const StyledLink = styled(Link).attrs((props) => ({
  className: buttonProp(props),
}))`
  ${(props) => {
    if (props.gamesearch) {
      return `
      display:flex;
      height: 70px;
      color: var(--styledLinkGamesearchColor);
      border: none;
      /* -webkit-box-shadow: 0px 0px 2px 0px var(--tabletext);
      -moz-box-shadow: 0px 0px 2px 0px var(--tabletext);
      box-shadow: 0px 0px 2px 0px var(--tabletext); */
      background-position: bottom;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-color: var(--styledLinkGamesearchBgColor);
      `;
    } else if (props.gotogames) {
      return `
        font-family: var(--styledLinkGotogamesFontFamily, inherit);
        white-space: nowrap;
        font-size: var(--styledLinkGotogamesFontSize);
      `;
    } else if (props.btnnext) {
      return `
        text-decoration: none !important;
        float: right;
        color: var(--acolor) !important;
        padding-right: 0 !important;

        &:after {
          font-family: 'Material Icons';
          content: 'play_circle';
          vertical-align: middle;
          font-size: 1.7rem;
          padding-left: 1rem;
        }

        @media (max-width: 767px) {
          width: auto;
        }
      `;
    } else if (props.tcpp) {
      return `
      color: #4d79ff;
      text-decoration: underline;
      &:hover {
        color: var(--brandcolor) !important;
      }
      `;
    } else if (props.semob) {
      return `
        background: white;
        margin: 1px;
        display: flex;
        padding: 3px;
        height: 100%;
      `;
    } else if (props.slidcontroll && props.slidcontroll) {
      return `
        font-size: var(--styledLinkSlidcontrollFontSize, 0.875rem);
        padding: var(--styledLinkSlidcontrollPadding, 0.75rem 0.75rem);
        color: var(--styledLinkSlidcontrollColor);
        border: var(--styledLinkSlidcontrollBorder);
        border-radius: var(--styledLinkSlidcontrollBorderRadius);
        background-color: var(--styledLinkSlidcontrollBgColor);
        width: var(--styledLinkSlidcontrollWidth);

        :hover {
          border-color: var(--styledLinkSlidcontrollHoverBorderColor);
          background-color: var(--styledLinkSlidcontrollHoverBgColor);
          color: var(--styledLinkSlidcontrollHoverColor, var(--styledLinkSlidcontrollColor));
        }

        @media(max-width: 768px){
          font-size: var(--styledLinkSlidcontrollMobileFontSize, 0.875rem);
          padding: var(--styledLinkSlidcontrollMobilePadding);
          margin-left: var(--styledLinkSlidcontrollMobileMarginLeft);
        }
      `;
    }
    if (props.pub) {
      return `
        text-transform: capitalize;
        width: 100px;
        padding: 0.5rem;
        border: ${
          props.goldenborder
            ? "2px solid #9A875D"
            : props.whiteborder
              ? "2px solid #fff"
              : ""
        };
        border-radius: 0.3rem;
        cursor: pointer;
        font-size: 1rem;
        color: ${props.logout ? "#9A875D" : ""};
  
        &:hover {
          border-color: ${props.goldenborder ? "#fff" : "#9A875D"};
        }
        &:disabled {
          &:hover {
            border-color: #fff;
          }
        }
        `;
    }
    if (props.extrasize) {
      return `
        width: 120px;
      `;
    }
    if (props.unclicable) {
      return `
        pointer-events: none;
      `;
    }
    if (props.limits) {
      return `
        font-size: 18px;
        text-decoration: underline;
        color: var(--styledLinkLimitsColor);
      `;
    }
  }}
`;

export const StyledNavLink = styled(NavLink).attrs((props) => ({
  className: "btn",
  activeClassName: "active",
}))`
  justify-content: var(--styledNavLinkJustifyContent);
  font-weight: var(--styledNavLinkFontWeight);
  padding: ${({ quickSB }) =>
    quickSB && (isMobile ? "0 10px" : "0 25px 0 0")};
  div {
    border-radius: var(--styledNavLinkDivBorderRadius);
    border: var(--styledNavLinkDivBorder);
  }
  background-image: var(--styledNavLinkBackgroundImage);
  &.active > div {
    background-color: var(--styledNavLinkActiveDivBgColor);
    border: var(--styledNavLinkActiveDivBorder);
    border-radius: var(--styledNavLinkActiveDivBorderRadius);
    svg {
      fill: var(--styledNavLinkActiveDivSvgFill);
      margin: auto;
    }
    // Fill for ABC icons
    .st0,
    .st4 {
      fill: #fff;
    }
    // Fill for PUB icons
    #mask-fill-icon {
      fill: var(--styledNavLinkMaskFillColor);
    }
  }
`;

export const StyledButton = styled.button.attrs((props) => ({
  className: buttonProp(props),
}))`
  #btn-live-chat-div {
    position: initial !important;
  }
  ${(props) => {
    if (props.searchbutton) {
      return `
        position: absolute;
        top: ${
          props.gamesearchinlobby
            ? "0"
            : props.mainsearch
              ? "2rem"
              : "var(--styledButtonSearchButtonTop)"
        };
        right: ${
          props.gamesearchinlobby
            ? "0px"
            : "var(--styledButtonSearchButtonRight)"
        };
        border: none;
        background: transparent;
        color: var(--styledButtonSearchButtonColor);
        cursor: pointer;
        &:after {
          font-family: 'Material Icons';
          content: 'cancel';
          vertical-align: middle;
          font-size: 1.5rem;
        }
        @media(max-width: 768px){
          top: ${
            props.gamesearchinlobby
              ? "0"
              : props.mainsearch
                ? "1.4rem"
                : "var(--styledButtonSearchButtonMobileTop)"
          };
          right : ${
            props.gamesearchinlobby
              ? "0px"
              : "var(--styledButtonSearchButtonMobileRight)"
          };
        }
      `;
    }
    if (props.supportchat) {
      return `
      padding: var(--styledButtonSupportChatPadding);
      border: var(--styledButtonSupportChatBorder);
      transition: all 0.5s ease;
      background-color: var(--styledButtonSupportChatBgColor, transparent);
      
      border-radius: var(--styledButtonSupportChatBorderRadius);
      color: var(--styledButtonSupportChatColor);
      /* margin-top: 2rem; */
      font-weight: 700 !important;
      cursor: pointer;
      div {
        color: var(--styledButtonSupportChatDivColor);
      }

      &:hover {
        background-color: var(--styledButtonSupportChatHoverBgColor, var(--styledButtonSupportChatBgColor, transparent));
        color: var(--styledButtonSupportChatHoverColor, var(--styledButtonSupportChatColor));
        border-color: var(--borderColor);
      }

      &:before {
          font-family: 'Material Icons';
          content: var(--styledButtonSupportChatBeforeContent);
          color: var(--styledButtonSupportChatBeforeColor);
          vertical-align: middle;
          font-size: 1rem;
        }
        @media (max-width: 767px) {
          /* margin-top: 1rem; */
          @media screen and (orientation: landscape) {
            padding: 0.5rem 1rem;
          }
        }
      `;
    }
    if (props.redemecode) {
      return `
      @media (max-width: 767px) {
        margin: 2rem 1rem;
      }
      
      `;
    }
    if (props.pub) {
      return `
      border: ${props.goldenborder ? "2px solid #9A875D" : "2px solid #fff"};
      border-radius: 0.3rem;
      cursor: pointer;

      &:hover {
        border-color: ${props.goldenborder ? "#fff" : "#9A875D"};
      }
      &:disabled {
        &:hover{ 
          border-color: #fff;
        }
      }
      `;
    }
    if (props.sweVerify) {
      return `
        background: url(${bankid});
        background-color: #15365d;
        background-repeat: no-repeat;
        background-position: center top;
        height: 48px;
      `;
    }
    if (props.gamedeposit) {
      return `
          color: #240090!important;
        `;
    }
    if (props.cancelWithdrawal) {
      return `
          padding: 0px 10px;
          vertical-align: baseline;
        `;
    }
  }}
`;

export const StyledSelect = styled.select.attrs((props) => ({
  className: selectProps(props),
}))``;

export const StyledInput = styled.input.attrs((props) => ({
  className: inputProps(props),
  autoFocus: autoFocusProps(props),
  autoComplete: "off",
}))`
  //remove arrows on all inputs
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: textfield;
  }
  text-transform: ${({ email }) =>
    email && "var(--styledInputEmailTextTransform, none)"};
  margin: ${({ validformWithdrawal }) => validformWithdrawal && "auto"};
  max-width: ${({ validformWithdrawal }) => validformWithdrawal && "30%"};
`;

export const StyledFormGroup = styled.div.attrs((props) => ({
  className: `form-group ${props.col} ${props.margin}`,
}))``;

export const StyledFormCheckInline = styled.div.attrs((props) => ({
  className: `form-check-inline ${props.disabled ? " disabled" : ""}`,
}))``;

export const StyledFormCheckLabel = styled.label.attrs((props) => ({
  className: `form-check-label ${props.margin ? "mr-3" : ""}`,
}))``;

export const StyledFlexTableCenter = styled.div.attrs((props) => ({
  className: `flex-table-row justify-content-center`,
}))``;

export const StyledFelxTableRow = styled.div.attrs((props) => ({
  className: `flex-table-row ${props.row && props.row}`,
}))`
  flex-wrap: ${({ total }) => (total ? "nowrap" : "")};
  display: ${({ display }) => (display ? "none" : "")};
  color: ${({ color }) => color && "black"};
`;

export const StyledFlexBetween = styled.div.attrs((props) => ({
  className: `d-flex justify-content-between ${props.mt}`,
}))`
  button {
    padding: ${({ special }) => special && "0 !important"};
  }
  margin-top: 1rem;
  @media (max-width: 767px) {
    button {
      font-size: 0.8rem;
      max-width: 120px;
    }
  }
`;

export const StyledFlexCenter = styled.div.attrs((props) => ({
  className: `d-flex justify-content-center ${props.mt}`,
}))``;

export const StyledMx = styled.span.attrs({
  className: "mx-3",
})``;

export const StyledMb = styled.span.attrs((props) => ({
  className: props.mb ? "mb-3" : "mb-4",
}))`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
`;

export const StyledCustomControlLabel = styled.label.attrs({
  className: "custom-control-label",
})``;

export const StyledFlexTable = styled.div.attrs({
  className: "flex-table",
})``;

export const LogoWrapper = styled.div.attrs((props) => ({
  className: `${
    hideLogoWrapperClassOnPlayerMobileBySkin[props.theme.skin] &&
    props.player &&
    isMobile
      ? ""
      : `d-flex ${isMobile ? "logo-abc-mobile" : "logo-abc"} logo-pointer `
  }`,
}))``;

export const VisibilityIcon = styled.div`
  text-align: right;
  position: relative;
  left: 100%;
  top: ${({ register, theme }) =>
    register ? "-57px" : "var(--visibilityIconTop)"};
  cursor: pointer;
  width: 0px;
  height: 0px;
  margin-left: ${({ reposition }) => (reposition ? "-56px" : "-30px")};

  &:after {
    font-family: "Material Icons";
    content: ${({ show }) => (show ? "'visibility'" : "'visibility_off'")};
    font-size: 1.2rem;
    color: ${({ theme }) =>
      theme.current === "dark"
        ? "var(--visibilityIconColorDark)"
        : "var(--visibilityIconColorLight)"};
  }
`;
